import { CountryTermRuleResponse } from '../models/country-config.dto';

const WILDCARD_EVENT_TYPE = '*';

/**
 * term -> countryCode -> localName, built only from wildcard ("every event type") rules.
 * A type-specific override (e.g. just for TransformationEvent) is deliberately left out — this
 * index backs the quick-reference matrix/compare views, not the exhaustive rule editor.
 */
export function buildLocalNameIndex(rules: CountryTermRuleResponse[]): Map<string, Map<string, string>> {
  const index = new Map<string, Map<string, string>>();
  for (const rule of rules) {
    if (rule.eventType !== WILDCARD_EVENT_TYPE || !rule.localName) {
      continue;
    }
    const byCountry = index.get(rule.term) ?? new Map<string, string>();
    byCountry.set(rule.countryCode, rule.localName);
    index.set(rule.term, byCountry);
  }
  return index;
}

/** The name a country calls a term — its override if one exists, else the canonical term itself. */
export function localNameFor(term: string, countryCode: string, index: Map<string, Map<string, string>>): string {
  return index.get(term)?.get(countryCode) ?? term;
}
